import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import { withStyles } from "@material-ui/core/styles";

const style = (theme) => ({
  tooltip: {
    backgroundColor: theme.ModalBGColor,
    color: theme.tooltipText,
    boxShadow: `-1px 5px 6px rgba(0, 0, 0, 0.2)`,
    padding: 5,
    fontSize: 12,
    opacity: 1,
    wordBreak: "break-word",
    border: `0.5px solid ${theme.gridGroupHeaderBorderColor}`,
  },
  popper: {
    opacity: 1,
  },
  tooltipPlacementRight: {},
});

const StyledToolTip = (props) => (
  <Tooltip
    enterDelay={200}
    innerRef={(tooltipRef) => {
      if (tooltipRef && tooltipRef.childrenRef) {
        // When a element is clicked hide the tooltip, so it behaves like default browser tooltip
        tooltipRef.childrenRef.onmousedown = tooltipRef.handleLeave;
        // When element is clicked and cursor position is not changed, it shows default browser tooltip which shouldn't happen
        // below code will hide this scenario Eg: Locking of routes/ terminal access user commands
        // It doesn't affect other functionality of the tooltip
        tooltipRef.childrenRef.onmouseup = () =>
          tooltipRef.childrenRef.setAttribute("title", "");
      }
    }}
    {...props}
  />
);

export default withStyles(style)(StyledToolTip);
